
import { Box } from '@chakra-ui/react'
import { SignalRProvider } from 'BrokerTsLib/src/context/SignalRProvider'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { SendCalculationModal, SendCalculationPropertyContextProvider } from '@/containers/SendCalculationModal'
import { SortBy } from '@/context/OffersProvider'
import { useApp } from '@/hooks/useApp'

import { Container } from '../../../components/Container'
import { Loading } from '../../../components/Loading'
import { Section } from '../../../components/Section'
import { Steps } from '../../../components/Steps'
import WizardForbiddenMessage from '../../../components/WizardForbiddenMessage'
import { InsuranceInfo } from '../../../containers/InsuranceInfo'
import { OfferPropertyCompare } from '../../../containers/offers/OfferPropertyCompare'
import PropertyOffersProvider from '../../../context/PropertyOffersProvider'
import { StepsContent } from '../../../context/StepsContext'
import { useInsuranceParamsContext } from '../../../layouts/Wizard'

const baseUrl = import.meta.env.VITE_BASE_URL
const hubUrl = import.meta.env.VITE_CALCULATION_HUB
const url = `${baseUrl}/${hubUrl}`

export const Step3 = () => {
  const { product, setProduct } = useApp()
  const navigate = useNavigate()
  const { insuranceParams, insuranceParamsId: paramsId, isLoadingData } = useInsuranceParamsContext()

  if (!isLoadingData && insuranceParams && (insuranceParams.generalParams?.lastWizardStep ?? 1) < 2) {
    navigate('/chaloupka/wizard/too-far', { replace: true })
  }

  const [order, setOrder] = useState(1)
  const setOrderFunc = (order: SortBy) => {
    switch (order) {
      case SortBy.Insurer:
        setOrder(3)
        break

      case SortBy.VariantInsurer:
        setOrder(2)
        break

      case SortBy.VariantPrice:
        setOrder(5)
        break

      default:
        setOrder(1)
        break
    }
  }

  useEffect(() => {
    if (insuranceParams?.generalParams?.insuranceCategoryType)
      setProduct(insuranceParams?.generalParams?.insuranceCategoryType)
  }, [insuranceParams?.generalParams?.insuranceCategoryType])

  return (
    <Section>
      <StepsContent step={3}>
        {isLoadingData && <Loading large={true} />}
        {(!paramsId || insuranceParams && product == insuranceParams.generalParams.insuranceCategoryType) && !isLoadingData &&
          <SignalRProvider url={url}>
            <PropertyOffersProvider>
              <Container>
                <Steps icon="house" />
              </Container>

              <SendCalculationPropertyContextProvider order={order}>
                <SendCalculationModal />
                <InsuranceInfo />
              </SendCalculationPropertyContextProvider>
              {/* pokud se nechá zde OfferPropertyCompare, tak je lišta v InsuranceInfo fixována k hornímu okraji, ale box s nabídkami není roztažený na celou šířku okna
                  <Box sx={{ px: 4 }}>
                    <OfferPropertyCompare />
                  </Box> */}

              <Box sx={{ px: 4 }}>
                <OfferPropertyCompare setOrderFunc={setOrderFunc} />
              </Box>


              <WizardForbiddenMessage />
            </PropertyOffersProvider>
          </SignalRProvider>
        }
      </StepsContent>
    </Section>

  )
}
